/**
 * Enumeration with http status codes
 */
export enum HttpStatus {
  /**
   * Application is not available.
   */
  CONNECTION_REFUSED = 0,
  /**
   * Request processed and returned expected response.
   */
  OK = 200,
  /**
   * Request doesn't exist.
   */
  BAD_REQUEST = 400,
  /**
   * Request is not authorized (no token)
   */
  UNAUTHORIZED = 401,
  /**
   * Request is not allowed (missing permission).
   */
  FORBIDDEN = 403,
  /**
   * Requested endpoint action is not found.
   */
  NOT_FOUND = 404,
  /**
   * Not acceptable.
   */
  NOT_ACCEPTABLE = 406,
  /**
   * Internal exception error.
   */
  INTERNAL_SERVER_ERROR = 500,
  /**
   * Requested operation is not implemented.
   */
  NOT_IMPLEMENTED = 501
}
